import React from "react";
import { Helmet } from "react-helmet-async";

const SEOHead = ({
  title,
  description,
  keywords,
  ogImage,
  canonicalUrl,
  structuredData,
}) => {
  const defaultTitle = "올려줌 - 순위 상위 노출 셀프 마케팅";
  const defaultDescription =
    "인스타그램, 유튜브, 틱톡, 스레드, 스마트스토어, 네이버플레이스까지 검색·방문·리뷰·저장·노출을 실제 유저가 직접 실행하는 리워드 트래픽 기반 마케팅 셀프마케팅의 해답, 셀러 대행사 중심 실행 플랫폼 올려줌.";
  const defaultKeywords =
    "셀프마케팅, 리워드마케팅, 인스타그램마케팅, 유튜브마케팅, 틱톡마케팅, 네이버플레이스, 스마트스토어, 마케팅플랫폼";
  const defaultUrl = "https://www.olzoom.com/";

  return (
    <Helmet>
      {/* 기본 메타 태그 */}
      <title>{title || defaultTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />

      {/* 캐노니컬 URL */}
      <link rel="canonical" href={canonicalUrl || defaultUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={title || defaultTitle} />
      <meta
        property="og:description"
        content={description || defaultDescription}
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl || defaultUrl} />
      <meta property="og:site_name" content="올려줌" />
      <meta property="og:locale" content="ko_KR" />
      {ogImage && <meta property="og:image" content={ogImage} />}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || defaultTitle} />
      <meta
        name="twitter:description"
        content={description || defaultDescription}
      />
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {/* 구조화된 데이터 */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
